
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dich-vu/[slug]",
      function () {
        return require("private-next-pages/dich-vu/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dich-vu/[slug]"])
      });
    }
  